import type { Config } from 'tailwindcss';

/** @type {import('tailwindcss').Config} */
export default {
  content: ['./index.html', './src/**/*.{js,ts,jsx,tsx}'],
  safelist: [
    'bg-primary/20',
    'bg-primary/40',
    'bg-primary/60',
    'bg-primary/80',
    'bg-primary/100',
    'hover:bg-opacity-[0.16]',
  ],
  theme: {
    extend: {
      fontFamily: {
        sans: ['DM Sans'],
      },
      fontSize: {
        xs: ['.75rem', '1rem'],
        sm: ['.875rem', '1.3125rem'],
        '3.5xl': ['2rem', '2.1875rem'],
      },
      colors: {
        primary: {
          DEFAULT: '#2540F5',
          100: '#EBEEFE',
          200: '#D3D9FD',
          300: '#E8EBFD',
          400: '#8796F9',
          500: '#2540F5',
          600: '#0900C7',
          700: '#000081',
        },
        secondary: {
          DEFAULT: '#00FF8B',
          500: '#00FF8B',
          600: '#00C76C',
          700: '#008F4E',
        },
        green: {
          DEFAULT: '#40DD19',
          500: '#40DD19',
          700: '#13965A',
        },
        orange: {
          DEFAULT: '#DB7805',
          300: '#E8AA00',
          500: '#DB7805',
        },
        red: { DEFAULT: '#D13637', 500: '#D13637', 100: '#FAEDED' },
        gray: {
          DEFAULT: '#787878',
          100: '#D9D9D9',
          200: '#DCE2E8',
          300: '#E5E5E5',
          400: '#B9B9B9',
          500: '#787878',
          600: '#7D7D7D',
          700: '#636363',
        },
        lightBlue: '#F8FAFB',
        black: {
          DEFAULT: '#222222',
          500: '#222222',
        },
      },
      height: {
        'full-device': '100dvh',
      },
      minHeight: {
        'full-device': '100dvh',
      },
      maxHeight: {
        'full-device': '100dvh',
      },
      boxShadow: {
        'sm-primary': '0px 4px 40px 0px #1C36E21A',
        md: '0px 4px 20px 0px rgba(3, 20, 82, 0.08)',
        whiteTopBar: '0 0 40px rgba(28, 54, 226, 0.1)',
        'md-primary': '0px 4px 40px 0px rgba(28, 54, 226, 0.1)',
        'step-footer': [
          '-71px -39px 23px 0px rgba(168, 168, 168, 0)',
          '-45px -25px 21px 0px rgba(168, 168, 168, 0.01)',
          '-25px -14px 17px 0px rgba(168, 168, 168, 0.05)',
          '-11px -6px 13px 0px rgba(168, 168, 168, 0.09)',
          '-3px -2px 7px 0px rgba(168, 168, 168, 0.10)',
        ].join(', '),
        'md-meetingSchedule': '-4px -4px 20px 0px #0314521F',
      },
      spacing: {
        '4.5': '18px',
        '5.5': '22px',
        '6.5': '26px',
        '12.5': '50px',
        '13.5': '55px',
        14: '56px',
        15: '60px',
        17: '68px',
        18: '72px',
        19: '76px',
        20.5: '82px',
        21: '84px',
        25: '100px',
        30: '120px',
        50: '200px',
        100: '400px',
        '102.5': '410px',
        '110.5': '442px',
        '132.5': '530px',
        '140.5': '562px',
        193: '763px',
      },
      maxWidth: {
        container: '1920px',
        'container-onb': '688px',
        'container-profile': '1168px',
        input: '320px',
        'input-profile': '350px',
        screen: '100dvw',
        sm: '560px',
        md: '684px',
        lg: '806px',
      },
      backgroundImage: {
        'ellipse-middle': "url('/src/assets/ellipse_middle.svg')",
        'ellipse-bottom': "url('/src/assets/ellipse_bottom.svg')",
        'ellipse-tl': "url('/src/assets/ellipse_tl.svg')",
        'mobile-ellipse-tl': "url('/src/assets/mobile-ellipse-tl.svg')",
        'mobile-ellipse-middle': "url('/src/assets/mobile-ellipse-middle.svg')",
        'custom-gradient': 'linear-gradient(160.096deg, #2540F5 0%, #0E1C7B 50%, #061052 77%)',
        'custom-gradient-mobile': 'linear-gradient(-178.321deg, #2540F5 0%, #061052 98%);',
        'button-gradient': 'linear-gradient(96.57deg, #2540F5 3.88%, #16258F 98.14%)',
        'otp-gradient': ' linear-gradient(166.719deg, #2540F5 0%, #061052 100%);',
        'primary-gradient-horizontal':
          'linear-gradient(168.71deg, #2540F5 21.81%, #061052 123.03%);',
        'air-gradient': 'linear-gradient(169deg, #2540F5 21.81%, #061052 123.03%);',
      },
    },
  },
  plugins: [],
} satisfies Config;
